import Base from '../Base';
import { useAPIContext } from '../../api/context';
import wizard from '../../utils/wizard';
import styles from './Layout.module.scss';

const Layout = ({ children, auth, step }) => {

  const { token } = useAPIContext();
  const { ready, missing } = wizard.useWizard(token);

  /*
   * In the signup flow (or while wizard data is loading), show the
   * full 4-step list with numbers. In the post-login completion flow,
   * show only the steps the user still needs to finish.
   */

  const signup = wizard.isSignup();

  let steps;

  if (signup || step === 'email') {
    steps = wizard.STEP;
  } else if (ready && missing.length > 0) {
    steps = wizard.stepsForNames(missing);
  } else {
    steps = wizard.STEP;
  }

  const showNumber = steps.length > 1;

  return (
    <Base auth={auth}>
      <div className={styles.root}>
        <div className={styles.inner}>

          <ul className={styles.steps}>
            {
              steps.map((item, i) => (
                <li
                  key={item.name}
                  className={item.name === step ? styles.active : ''}>

                  {
                    showNumber && (
                      <span>{i + 1}</span>
                    )
                  }
                  <span>{item.label}</span>

                </li>
              ))
            }
          </ul>

          <div className={styles.content}>
            {children}
          </div>

        </div>
      </div>
    </Base>
  );
};

export default Layout;
